export const showcasePagePanelClassName = 'rounded-lg bg-[var(--color-page)] p-4';
